let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8hbZ5"), load("3yFtm")]).then(() => parcelRequire('dQUV0'));